<template>
  <div class="panel-topbar">
    <div class="panel-topbar__left">
      <div class="topbar-legend">
        <span class="legend-dot legend-dot--delivery"></span>
        <span class="legend-label">Saída de locação</span>
        <span class="legend-dot legend-dot--devolution"></span>
        <span class="legend-label">Retorno de locação</span>
      </div>
    </div>
    <div class="panel-topbar__right">
      <span class="topbar-badge">
        <i class="fa-solid fa-layer-group topbar-badge__icon"></i>
        {{ sizeFullData }} registro{{ sizeFullData !== 1 ? 's' : '' }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "OsPanelCardItemTopbar",
  props: {
    sizeFullData: {type: Number, default: 0},
  },
};
</script>

<style scoped>
.panel-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin: 14px 0;
  padding: 10px 16px;
  background: #ffffff;
  border: 1px solid #e8ecf3;
  border-radius: 10px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04);
}

.panel-topbar__left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.panel-topbar__right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.topbar-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 600;
  color: #6b7280;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  padding: 4px 12px;
  white-space: nowrap;
}

.topbar-badge__icon {
  font-size: 11px;
  color: #9ca3af;
}

.topbar-legend {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.legend-dot--delivery {
  background-color: #009183;
}

.legend-dot--devolution {
  background-color: #3d4eae;
}

.legend-label {
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
  margin-right: 6px;
}
</style>
